<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    localChartData: null
  }),
  methods: {
    updateChart () {
      this.$data._chart.update()
    }
  },
  mounted () {
    this.addPlugin({
      id: 'my-plugin',
      beforeDraw: function (chart) {
        if (chart.config.data.text) {
          var text = chart.config.data.text
          // Get ctx from string
          var ctx = chart.chart.ctx

          // initialize default config
          var font = 'Arial'
          var color = '#000'
          var padding = 20
          // Get options from the center object in options
          var textConfig = chart.config.options.text
          if (textConfig !== undefined) {
            font = textConfig.font !== undefined ? textConfig.font : 'Arial'
            color = textConfig.color !== undefined ? textConfig.color : '#000'
            padding = textConfig.padding !== undefined ? textConfig.padding : 20
          }
          var paddingCalculated = (padding / 100) * (chart.innerRadius * 2)
          // Start with a base font of 30px
          ctx.font = '30px ' + font

          // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(text).width
          var elementWidth = (chart.innerRadius * 2) - paddingCalculated

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth
          var newFontSize = Math.floor(30 * widthRatio)
          var elementHeight = (chart.innerRadius * 2)

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight)

          // Set font settings to draw it correctly.
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2)
          var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2)
          ctx.font = fontSizeToUse + 'px ' + font
          ctx.fillStyle = color

          // Draw text in center
          ctx.fillText(text, centerX, centerY)
        }
      }
    })
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      handler: function () {
        // this.renderChart(this.chartData, this.options)
        console.log('Updating chart')
        this.$data._chart.update()
      },
      deep: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// DoughnutChart.vue?fa3b2adc